import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import './loading.css';

const Loading = (props) => {
    return <div className='lykiocss-loading-center'><Loader
    type={props.type ? props.type : "Grid"} // options Grid, Bars, Hearts, TailSpin, ThreeDots
    color="grey"
    height={100}
    width={100}
    /></div>;
}

export default Loading;